<template>
  <vs-popup title="Assinatura" :active.sync="open" @close="closeModal">
    <div>
      <p>Assine dentro do espaço marcado abaixo</p>
      <VueSignaturePad
        id="signature"
        width="100%"
        height="200px"
        class="mt-2"
        ref="signaturePad"
        :options="{
          onBegin: () => {
            $refs.signaturePad.resizeCanvas();
          },
        }"
      />

      <div class="flex justify-between sm:justify-end mt-4">
        <div class="flex w-full sm:w-1/2 gap-4">
          <vs-button
            class="w-full my-1"
            color="danger"
            icon-pack="feather"
            icon="icon-trash"
            @click="desfazerAssinatura"
          >
            Desfazer
          </vs-button>
          <vs-button
            class="w-full my-1"
            color="success"
            icon-pack="feather"
            icon="icon-paperclip"
            @click="salvarAssinatura"
          >
            Salvar
          </vs-button>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import service from '../../services';
import canvasToBlob from 'blueimp-canvas-to-blob';

export default {
  props: {
    openModal: {
      type: Boolean,
      default: false,
    },
    idFrota: Number,
  },
  watch: {
    openModal(value) {
      if (value) {
        this.open = value;
      }
    },
  },
  data() {
    return {
      open: false,
      files: new FormData(),
    };
  },
  methods: {
    desfazerAssinatura() {
      this.$refs.signaturePad.undoSignature();
    },
    async salvarAssinatura() {
      try {
        const { data, isEmpty } = this.$refs.signaturePad.saveSignature();

        if (isEmpty) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'É preciso enviar algum conteudo em sua assinatura, por favor preencha o campo.',
            color: 'danger',
          });
          return;
        }
        this.$vs.loading();
        const blob = canvasToBlob(data);
        this.files.set('file', blob, 'assinatura.png');

        const linkRetorno = await service.upload(
          'Upload',
          'Assinatura/' + this.idFrota,
          this.files,
        );
        if (linkRetorno) {
          this.open = false;
          this.$emit('uploadAssinatura', linkRetorno);
          this.$vs.loading.close();
          return;
        }
      } catch {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível realizar upload da assinatura',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    closeModal() {
      this.undo();
      this.open = false;
      this.$emit('closeModalAssinatura');
    },
  },
};
</script>
<style scoped>
#signature {
  border: 1px solid grey;
}
</style>
